import * as R from 'ramda'
import { properties, projects, transactions, tasks, tenants, leases } from './entities'
import { transactionsEx } from './transactions'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { leaseFilter } from './lease'
import { propertiesEx } from './properties'

let entities = {
    property: propertiesEx
  , transaction: transactionsEx
  , project: projects
  , task: tasks
  , tenant: tenants
  , lease: leaseFilter
}

export let currentFilter = entity => state => state.currentFilters[entity]//.predefined

let combineSelectors = (selectorsMap) => (state, props) => selectorsMap && R.map(
	selector => selector(state, props)
  , selectorsMap
)

let makeFilterSelector = (collection, predicate) => {
	let selectors = [collection]
	if (predicate.context) selectors.push(combineSelectors(predicate.context))
	return createSelector(
		selectors
	  , (collection, ...rest) => (
			R.filter(
				x => (predicate.fn || predicate)(x, rest[0])
			  , collection
			)
		)
	)
}

let makeFilterSelectors = (filters, entityKey) => {
	let entitySelector = entities[entityKey]
	return R.map(
		filter => makeFilterSelector(entitySelector, filter)
	  , filters
	)
}

let filters = R.mapObjIndexed(makeFilterSelectors, {
    property: {
        'All Properties': x => x
      , 'For Rent': x => x.status.forRent == 'For Rent' && !x.dateTill
      , 'Not in Service': x =>  x.status.forRent !== 'For Rent' &&  x.status.occupied !== 'Occupied' && !x.dateTill
      , 'Occupied': x => x.status.occupied == 'Occupied' && !x.dateTill
      , 'Retired': x => !!x.dateTill
    }
  , project: {
		'All Projects': x => x
	  , 'Open Projects': x => x.status == 'Open'
	  // , 'My open': {fn: (x, context) => x.status == 'Open' && x.owner == context.currentUser, context: {currentUser}}
	  , 'Closed Projects': x => x.status == 'Closed'
    }
  , transaction: {
		'All Transactions': x =>  x
	  , 'Bills': x => x.type == 'transaction/bill'
	  , 'Paid Bills': x => x.type == 'transaction/bill' && x.balance <= 0
	  , 'Unpaid Bills': x => x.type == 'transaction/bill' && x.balance > 0
	  , 'Invoices': x => x.type == 'transaction/invoice'
    , 'Payments': x => x.type == 'transaction/invoice-payment'
	  , 'Paid Invoices': x => x.type == 'transaction/invoice' && x.balance <= 0
	  , 'Unpaid Invoices': x => x.type == 'transaction/invoice' && (x.balance > 0 || x.amount == 0)
    }
  , task: {
  		'All Tasks': x =>  x
      , 'Open Tasks': x =>  !x.done
    }
  , tenant: {
  		'Tenants': x =>  x
    }
  , lease: {
  		'All Leases': x =>  x
      , 'Active Leases': x =>  x.active
    }
})

export default filters

export let filteredCollection = entity => state => {
	let curr= currentFilter(entity)(state)
	let filter = filters[entity][curr](state)
	return filter
}

// //how to use
// import filter from 'selectors/filter' //current filter state.filter.properties(y)  string
// import filteredCollection from 'filters'
//
// let select = (state, props) => ({
// 	properties: filteredCollection('property')(state)
//   , filter: filter('property')(state)
// })



// WEBPACK FOOTER //
// ./src/selectors/filters.js